import ICONS from '@/assets/icons'
import { PATHS } from '@/config/path'

export type NormalMenuType = {
  id: number
  label: string
  icon: string
  active: string
  hasNoti: boolean
  isNew: boolean
}

export type TMenuData = NormalMenuType &
  (
    | {
        type: 'item'
        path: string
      }
    | {
        type: 'dropdown'
        children: (Omit<NormalMenuType, 'icon' | 'active'> & { path: string })[]
      }
  )

export const ItemMenuData: TMenuData[] = [
  {
    id: 1,
    label: 'Home',
    icon: ICONS.home,
    active: ICONS.homeActive,
    path: '/feed',
    type: 'item',
    hasNoti: false,
    isNew: false,
  },
  {
    id: 2,
    label: 'Notifications',
    icon: ICONS.notification,
    active: ICONS.notificationActive,
    path: '/notifications',
    type: 'item',
    hasNoti: true,
    isNew: false,
  },
  // {
  //   id: 3,
  //   label: 'Message',
  //   icon: ICONS.message,
  //   active: ICONS.messageActive,
  //   path: '/message',
  //   type: 'item',
  //   hasNoti: true,
  // },
  {
    id: 3,
    label: 'KOLs',
    icon: ICONS.starKOL,
    active: ICONS.starKOLActive,
    path: '/kol',
    type: 'item',
    hasNoti: true,
    isNew: false,
  },
  {
    id: 4,
    label: 'Spaces',
    icon: ICONS.icSpace,
    active: ICONS.icSpaceActive,
    path: '/spaces',
    type: 'item',
    hasNoti: true,
    isNew: false,
  },
  {
    id: 5,
    label: 'Events & Campaigns',
    icon: ICONS.event,
    active: ICONS.eventActive,
    path: '/events',
    type: 'item',
    hasNoti: true,
    isNew: false,
  },
  // {
  //   id: 9,
  //   label: 'Meme Signals',
  //   icon: ICONS.memeSignal,
  //   active: ICONS.memeSignalActive,
  //   path: '/meme-signals',
  //   type: 'item',
  //   hasNoti: false,
  //   isNew: false,
  // },
  // {
  //   id: 7,
  //   label: 'KOLs Following',
  //   icon: ICONS.icChart,
  //   active: ICONS.icChartActive,
  //   path: '/kols-following',
  //   type: 'item',
  //   hasNoti: true,
  // },
  // {
  //   id: 6,
  //   label: 'SST Staking',
  //   icon: ICONS.icStaking,
  //   active: ICONS.icStakingActive,
  //   path: '/sst-staking',
  //   type: 'item',
  //   hasNoti: true,
  // },
  {
    id: 10,
    label: 'Referral Program',
    icon: ICONS.icCoinHand,
    active: ICONS.icCoinHandActive,
    path: '/referral-program',
    type: 'item',
    hasNoti: false,
    isNew: true,
  },
  {
    id: 11,
    label: 'PumpFun Pre-Launch',
    icon: ICONS.icPump,
    active: ICONS.icPumpActive,
    path: '/pump-fun',
    type: 'item',
    hasNoti: true,
    isNew: false,
  },
  {
    id: 6,
    label: 'Wallet',
    icon: ICONS.wallet,
    active: ICONS.walletActive,
    path: '/wallet',
    type: 'item',
    hasNoti: true,
    isNew: false,
  },
  {
    id: 7,
    label: 'Profile',
    icon: ICONS.user,
    active: ICONS.usersActive,
    path: '/profile',
    type: 'item',
    hasNoti: false,
    isNew: false,
  },
  // {
  //   id: 9,
  //   label: 'AI Market Maker',
  //   icon: ICONS.icMarket,
  //   active: ICONS.icMarketActive,
  //   path: '/AI-market-maker',
  //   type: 'item',
  //   hasNoti: false,
  // },
  // {
  //     id: 8,
  //     label: 'My Space',
  //     icon: ICONS.more,
  //     active: ICONS.moreActive,
  //     type: 'dropdown',
  //     children: [
  //         {
  //             id: 1,
  //             label: 'My Profile',
  //             path: '/profile',
  //         },
  //         {
  //             id: 2,
  //             label: 'Wallet Information',
  //             path: '/wallet',
  //         },
  //         {
  //             id: 3,
  //             label: 'Key Management',
  //             path: '/my-space/detail',
  //         },
  //         {
  //             id: 4,
  //             label: 'Event Management',
  //             path: '/event-manager',
  //         },
  //         // {
  //         //     id: 5,
  //         //     label: 'Ranking',
  //         //     path: '/wallet',
  //         // },
  //     ],
  // },
]

export const ItemMenuDataMobile: TMenuData[] = [
  {
    id: 1,
    label: 'Profile',
    icon: ICONS.user,
    active: ICONS.usersActive,
    path: '/profile',
    type: 'item',
    hasNoti: false,
    isNew: false,
  },
  {
    id: 2,
    label: 'KOLs',
    icon: ICONS.starKOL,
    active: ICONS.starKOLActive,
    path: '/kol',
    type: 'item',
    hasNoti: true,
    isNew: false,
  },
  {
    id: 3,
    label: 'Events & Campaigns',
    icon: ICONS.event,
    active: ICONS.eventActive,
    path: '/events',
    type: 'item',
    hasNoti: true,
    isNew: false,
  },
  {
    id: 10,
    label: 'Meme Signals',
    icon: ICONS.memeSignal,
    active: ICONS.memeSignalActive,
    path: '/meme-signals',
    type: 'item',
    hasNoti: false,
    isNew: false,
  },
  // {
  //   id: 5,
  //   label: 'KOLs Following',
  //   icon: ICONS.icChart,
  //   active: ICONS.icChartActive,
  //   path: '/kols-following',
  //   type: 'item',
  //   hasNoti: true,
  // },

  // {
  //   id: 2,
  //   label: 'Message',
  //   icon: ICONS.message,
  //   active: ICONS.messageActive,
  //   path: '/message',
  //   type: 'item',
  //   hasNoti: true,
  // },

  // {
  //   id: 5,
  //   label: 'SST Staking',
  //   icon: ICONS.icStaking,
  //   active: ICONS.icStakingActive,
  //   path: '/sst-staking',
  //   type: 'item',
  //   hasNoti: true,
  // },
  {
    id: 6,
    label: 'Spaces',
    icon: ICONS.icSpace,
    active: ICONS.icSpaceActive,
    path: '/spaces',
    type: 'item',
    hasNoti: true,
    isNew: false,
  },
  {
    id: 11,
    label: 'Referral Program',
    icon: ICONS.icCoinHand,
    active: ICONS.icCoinHand,
    path: '/referral-program',
    type: 'item',
    hasNoti: false,
    isNew: true,
  },
  {
    id: 12,
    label: 'PumpFun Pre-Launch',
    icon: ICONS.icPump,
    active: ICONS.icPumpActive,
    path: '/pump-fun',
    type: 'item',
    hasNoti: true,
    isNew: false,
  },
  {
    id: 7,
    label: 'Wallet',
    icon: ICONS.wallet,
    active: ICONS.walletActive,
    path: '/wallet',
    type: 'item',
    hasNoti: true,
    isNew: false,
  },
  {
    id: 8,
    label: 'Notifications',
    icon: ICONS.notification,
    active: ICONS.notificationActive,
    path: '/notifications',
    type: 'item',
    hasNoti: true,
    isNew: false,
  },
  {
    id: 9,
    label: 'Tutorial Playlist',
    icon: ICONS.support,
    active: ICONS.support,
    path: 'https://youtube.com/playlist?list=PLqPbMrfq-cRmS91wVRz4N9uiGLVRmTQW1&si=2YqlyhYn9K4pWfA-',
    type: 'item',
    hasNoti: true,
    isNew: false,
  },
]

export const ItemMenuMoreData = [
  {
    id: 1,
    label: 'Create new Space',
    icon: ICONS.plusCircleWhite,
    path: '/spaces/create',
    type: 'item',
    isMobile: true,
  },
  // {
  //   id: 1,
  //   label: 'Settings',
  //   icon: ICONS.setting,
  //   path: '/settings',
  //   type: 'item',
  //   isMobile: true,
  // },
  {
    id: 4,
    label: 'Tutorial Playlist',
    icon: ICONS.support,
    path: 'https://youtube.com/playlist?list=PLqPbMrfq-cRmS91wVRz4N9uiGLVRmTQW1&si=2YqlyhYn9K4pWfA-',
    isMobile: false,
  },
  // {
  //   id: 2,
  //   label: 'Support',
  //   icon: ICONS.support,
  //   path: 'https://t.me/sightseacommunity',
  //   isMobile: false,
  // },
  {
    id: 3,
    label: 'Logout',
    icon: ICONS.signOut,
    path: PATHS.SIGNIN,
    type: 'item',
    isMobile: true,
  },
]
